import { render, staticRenderFns } from "./PheProjectSelectionDetails.vue?vue&type=template&id=27495ffb&"
import script from "./PheProjectSelectionDetails.vue?vue&type=script&lang=js&"
export * from "./PheProjectSelectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PheProjectSelectionDetails.vue?vue&type=style&index=0&id=27495ffb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports